/**
 * Script pour intercepter l'ajout au panier et afficher le modal d'upsell
 * au lieu d'ouvrir directement le cart drawer
 */

(function() {
  
  // Variables de contrôle
  window.productUpsellActive = true;
  window.allowCartDrawerOpen = false;
  
  // Attendre que le DOM soit chargé
  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
  } else {
    init();
  }

  function init() {
    
    // Intercepter l'événement cart:refresh sur documentElement (pas document!)
    document.documentElement.addEventListener('cart:refresh', handleCartRefresh, true);
    
    // Intercepter aussi le formulaire directement
    interceptProductForm();
    
    // Intercepter l'ouverture du drawer
    interceptDrawerOpen();
  }

  function handleCartRefresh(event) {

    // Vérifier si on doit ouvrir le mini cart
    if (event.detail && event.detail.openMiniCart === true && window.productUpsellActive) {

      // Empêcher l'ouverture automatique du cart drawer
      event.stopImmediatePropagation();
      event.preventDefault();

      // Récupérer le handle du produit ajouté si disponible
      const addedProductHandle = event.detail.product?.handle || null;

      // Afficher le modal d'upsell à la place
      setTimeout(() => {
        if (typeof openProductUpsellModal === 'function') {
          openProductUpsellModal(addedProductHandle);
        } else {
          console.error('❌ openProductUpsellModal function not found');
        }
      }, 150);

      return false;
    }
  }

  function interceptProductForm() {
    // Observer pour détecter les formulaires de produit
    const observer = new MutationObserver(() => {
      const productForms = document.querySelectorAll('form[is="ap-productform"]');
      productForms.forEach(form => {
        if (!form.dataset.intercepted) {
          form.dataset.intercepted = 'true';
        }
      });
    });
    
    observer.observe(document.body, {
      childList: true,
      subtree: true
    });
    
    // Intercepter immédiatement les formulaires existants
    const existingForms = document.querySelectorAll('form[is="ap-productform"]');
    existingForms.forEach(form => {
      form.dataset.intercepted = 'true';
    });
  }

  function interceptDrawerOpen() {
    // Intercepter l'ouverture du drawer
    const checkDrawer = setInterval(() => {
      const drawer = document.querySelector('ap-cartdrawer');
      if (drawer && !drawer.dataset.intercepted) {
        drawer.dataset.intercepted = 'true';
        
        // Override la méthode open
        const originalOpen = drawer.open;
        if (originalOpen) {
          drawer.open = function(...args) {
            if (!window.allowCartDrawerOpen && window.productUpsellActive) {
              return;
            }
            return originalOpen.apply(this, args);
          };
        }
        
        clearInterval(checkDrawer);
      }
    }, 100);
    
    // Arrêter après 5 secondes
    setTimeout(() => clearInterval(checkDrawer), 5000);
  }
})();

